import { Country } from '@nkr/enums/country';
import { DonationType } from '@nkr/enums/donation-type';
import { DonorType } from '@nkr/enums/donor-type';
import { MatchStatus } from '@nkr/enums/match-status';
import { IDonorProfileContact } from './contact';
import { IListItem } from '../list-item';
import { IState } from '../state';
import { ICenterBase } from '../center-base';
import { DonorProfileType, RemoteEvalStatus } from '@nkr/enums/index';

export interface IDonorProfileDonorData {
    donorId: number,
    centerId: number,
    registrationDate: string,
    firstExportableDate: string,
    mrn: string,
    crossReferenceHint: string,
    matchStatus: MatchStatus,
    donorType: DonorType,
    declinedAdpReason: number,
    declinedAdpReasonOther: string,
    isActive: boolean,
    surgeonContactId: number,
    isRemoteDirect: boolean,
    donationStartDate: string,
    donationEndDate: string,
    isWorkedUp: boolean,
    originalRecipientId: number,
    relationshipToRecipient: string,
    relationshipToPatientOther: string,
    unosId: string,
    centerIsAllowedLocalCryo: boolean,
    hasFrozenSamples: boolean,
    vialsAtNkrLab: number,
    isViableBridge: boolean,
    alias: string,
    coordinatorId: number,
    isRemotePhlebo: true,
    usePhlebotomy: boolean
    directCryoSend: boolean,
    directXmSend: boolean,
    directSerologySend: boolean,
    fullName: string,
    country: Country,
    addressLine1: string,
    addressLine2: string,
    city: string,
    state: string,
    postalCode: string,
    birthDate: string,
    phone: string,
    email: string,
    rdnCenterId: number,
    remoteWorkupCenterId: number,
    remoteWorkupDate: string,
    remoteWorkupBilledDate: string,
    didRemoteWorkup: number,
    donationType: DonationType,
    donationTypeDescription: string,
    comments: string,
    hasCtScanOnline: boolean,
    hasSamplesAtViracor: boolean,
    isAdp: boolean,
    isDirect: boolean,
    isInternalDirect: boolean,
    viewType: DonorProfileType,
    lastCryoOrder: string,
    isChainStarter: boolean,
    isRemoteCenter: boolean,
    canChangeAlias: boolean,
    adpFormPath: string,
    voucherConsentsReviewed: boolean,
    consentForm?: File,
    appendConsentForm?: boolean,
}

export interface IDonorProfileDonorDataLookupData {
    contactList: IDonorProfileContact[],
    donationTypeList: IListItem[],
    countryList: IListItem[],
    stateList: IState[],
    declineAdpReasonList: IListItem[],
    relationshipToPatientList: IListItem[],
    remoteEvalStatusList: IListItem[],
    centerList: IListItem[]
}

export interface IDonorProfileDonorDataPost {
    mrn: string;
    crossReferenceHint: string;
    declinedAdpReason: number;
    declinedAdpReasonOther: string;
    isActive: boolean;
    surgeonContactId: number;
    isRemoteDirect: boolean;
    donationStartDate: string;
    donationEndDate: string;
    isWorkedUp: boolean;
    originalRecipientId: number;
    relationshipToRecipient: string;
    relationshipToPatientOther: string;
    unosId: string;
    hasFrozenSamples: boolean;
    isViableBridge: boolean;
    alias: string;
    coordinatorId: number;
    usePhlebotomy: boolean;
    directCryoSend: boolean;
    directXmSend: boolean;
    directSerologySend: boolean;
    rdnCenterId: number;
    remoteWorkupCenterId: number,
    remoteWorkupDate: string;
    remoteWorkupBilledDate: string,
    didRemoteWorkup: RemoteEvalStatus;
    comments: string,
    voucherConsentsReviewed: boolean,
    consentForm?: File,
    appendConsentForm?: boolean,
}